import type { User } from "@/types/auth";

import {
  isSmsRegistrationEnabled,
  useIsSmsRegistrationEnabled,
} from "@/features/Settings/flag";
import {
  hasElevatedAccessValue,
  useHasElevatedAccess,
  usePrivilegedModeStore,
} from "@/utils/privilegedMode";

export interface SmsRegistrationRouteRedirect {
  to: "/dragon-tiles/$siteId";
  params: { siteId: string };
}

export function smsRegistrationRouteRedirect(
  role: User["role"] | null | undefined,
  siteId: string,
): SmsRegistrationRouteRedirect | null {
  const disabled = usePrivilegedModeStore.getState().disabled;
  if (isSmsRegistrationEnabled() && hasElevatedAccessValue(role, disabled)) {
    return null;
  }
  return { to: "/dragon-tiles/$siteId", params: { siteId } };
}

export function useSmsRegistrationAccess(): boolean {
  const enabled = useIsSmsRegistrationEnabled();
  const isStaff = useHasElevatedAccess();
  return enabled && isStaff;
}
